import type { FaireProductEntity } from "../../entity_types/product";

export const p_55gbay0rfy: FaireProductEntity = {
  token: "p_55gbay0rfy",
  type: "product",
  name: "Bambini Infant Blue Gown",
  brandToken: "b_2mjydukmqy",
  brandName: "Bambini Infant Wear inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/7c6bb2d5d23a71ce69e2491e144973c2d8387a211a4d2740c67f5e038a842256.jpeg",
  galleryImageUrls: [],
  priceDollars: 3.47,
  description:
    "Blue Infant Gown With Long Sleeve with Mitten Cuffs are the best way to keep your little one warm all night long; especially in the Autumn and Winter months. With the built-in mittens, their hands will be kept nice and toasty so you can even have him bundled up in it for any outdoor time in the evening. \nCovered Elastic Bottom.\n\n100% Cotton 1x1 Rib Knit.\n\nSize: One Size.    Newborn Up to 6 Months\n\nColors: Blue.\n\nItem sold loose bulk without packaging.\n\n1 Per Pack.",
  tags: [],
  msrpDollars: 8.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:16.706Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
